export const InputTheme = {
  variants: {
    outline: {
      field: {
        background: 'brand.formInputBgColor',
        borderColor: 'brand.formInputBgColor',

        _focus: {
          borderColor: 'brand.fontColor',
          boxShadow: `0 0 0 1px brand.offBlack`,
          color: 'brand.fontColor',
        },

        _invalid: {
          borderColor: 'brand.pink',
          boxShadow: '0 0 0 1px brand.pink',
          color: 'brand.pink',
        },

        _valid: {
          background: 'blue'
        }
      },
    },
  },
  defaultProps: {
    size: 'lg'
  }
}